import { useTeamContext } from '../context';
import { TeamInfo } from '../context/types';

export function useTeamInfo(): TeamInfo | null {
  const { teamInfo } = useTeamContext();
  return teamInfo;
}
